import React, { useState, useEffect } from 'react';
import pb from '../lib/pocketbase';
import './CreationsPage.css';

const CreationsPage = () => {
    const [pastries, setPastries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCreation, setSelectedCreation] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchSouvenirs = async () => {
            try {
                // Fetch all souvenirs, sorted by newest first
                const records = await pb.collection('patisseries').getList(1, 100, {
                    filter: 'estSouvenir = true',
                    sort: '-created'
                });

                const formatted = records.items.map(record => ({
                    id: record.id,
                    name: record.nom,
                    description: record.description,
                    image: record.photo ? pb.files.getURL(record, record.photo) : null,
                    date: record.dateTexte ? record.dateTexte : new Date(record.created).toLocaleDateString('fr-FR', {
                        year: 'numeric',
                        month: 'long'
                    }),
                    season: "Archive de la Maison" // Default label
                }));

                setPastries(formatted);
            } catch (err) {
                console.error("Error fetching souvenirs:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchSouvenirs();
    }, []);

    if (loading) return <div className="loading-state">Préparation des archives...</div>;

    return (
        <div className="creations-page-container">
            {/* Header / Hero */}
            <div className="creations-header">
                <div className="creations-header-content">
                    <span className="creations-subtitle">Les Archives Gourmandes</span>
                    <h1 className="creations-title">Nos créations</h1>
                    <p className="creations-header-text">
                        Découvrez l'héritage de la Maison Cédric Millet. Un voyage dans le temps à travers nos pâtisseries disparues, témoins d'une recherche constante d'excellence et d'émotion au fil des saisons.
                    </p>
                </div>
            </div>

            {/* Gallery Grid */}
            <div className="creations-grid-container">
                <div className="creations-grid">
                    {pastries.map((creation) => (
                        <div
                            key={creation.id}
                            className="creation-card"
                            onClick={() => setSelectedCreation(creation)}
                        >
                            <div className="creation-image-wrapper">
                                {creation.image ? (
                                    <img src={creation.image} alt={creation.name} className="creation-image" />
                                ) : (
                                    <div className="creation-image-placeholder">Souvenir</div>
                                )}
                                <div className="creation-overlay">
                                    <span className="view-details">Découvrir l'histoire</span>
                                </div>
                            </div>
                            <div className="creation-info">
                                <span className="creation-season">{creation.date}</span>
                                <h3 className="creation-name">{creation.name}</h3>
                                <p className="creation-card-description">{creation.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                {pastries.length === 0 && (
                    <div className="no-souvenirs text-center" style={{ padding: '80px 20px', color: '#999' }}>
                        <p>Nos archives sont en cours de numérisation...</p>
                    </div>
                )}
            </div>

            {/* Modal for Details */}
            {selectedCreation && (
                <div className="creation-modal-overlay" onClick={() => setSelectedCreation(null)}>
                    <div className="creation-modal-content" onClick={e => e.stopPropagation()}>
                        <button className="creation-modal-close" onClick={() => setSelectedCreation(null)}>&times;</button>
                        <div className="creation-modal-split">
                            <div className="creation-modal-image-side">
                                <img src={selectedCreation.image} alt={selectedCreation.name} />
                            </div>
                            <div className="creation-modal-info-side">
                                <span className="modal-season">{selectedCreation.date}</span>
                                <h2>{selectedCreation.name}</h2>
                                <div className="modal-divider"></div>
                                <p className="modal-description">{selectedCreation.description}</p>
                                <p className="modal-note">
                                    <em>Cette création faisait partie de notre collection éphémère et n'est actuellement plus disponible en boutique, afin de respecter le cycle des saisons et notre quête d'innovation.</em>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CreationsPage;
